import React from 'react'
import {
    FontAwesomeIcon,
    FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCircleNotch } from '@fortawesome/pro-duotone-svg-icons'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LoadingProps } from './loading.types'
import { getPixelSize } from './loadingUtils'

type LoadingDefaultProps = LoadingProps & {
    icon?: IconDefinition // optional, default to faCircleNotch
}

const LoadingDefault: React.FC<LoadingDefaultProps> = ({
    size = 'md',
    message = '',
    icon = faCircleNotch,
}) => {
    // If size is a custom pixel size, map it; otherwise use FA size string
    const pixelSize = getPixelSize(size)

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            <FontAwesomeIcon
                icon={icon}
                spin
                style={{
                    ...(pixelSize ? { fontSize: pixelSize } : {}),
                    animationDuration: '1.25s', // faster than default 2s
                }}
                size={
                    pixelSize
                        ? undefined
                        : (size as FontAwesomeIconProps['size'])
                }
            />
            {message && (
                <Typography variant="body2" sx={{ ml: 1 }}>
                    {message}
                </Typography>
            )}
        </Box>
    )
}

export default LoadingDefault
